import { Routes } from '@angular/router';
import { DEFAULT_ROUTES } from 'src/environments/routes';
import {
  AuthGuard,
  LaunchDarklyTenantGuard,
  LaunchDarklyUserGuard, RoleBasedGuard
} from 'remarketing-angular-library';
import { LoginGuard } from './guards/login/login.guard';
import { BrowserSuggestionComponent } from './modules/browser-suggestion/components/browser-suggestion/browser-suggestion.component';
import { DefaultGuard } from './guards/default/default.guard';

import {
  AuthCodeComponent,
  AdminErrorGuard,
  AdminErrorComponent,
  WhiteLabelCallbackGuard,
  AdminLoginGuard,
  ForgotUsernameComponent,
  ErrorComponent,
  LogoutComponent,
  LoginComponent,
  AdminTransportationGuard,
  FinanceSourceFeeGuard,
  DataUtilityGuard,
  BuyFeeGroupsGuard,
  DealerSearchGuard,
  LegacyCallbackGuard,
  AgreementsGuard,
  GUARDS,
  HolidayScheduleGuard,
  SimulcastLandingGuard,
  MessageMaintenanceGuard,
  BranchMaintenanceGuard,
  AddStorageLocationGuard,
  DealerSearchV2Guard,
  FeedSubmitGuard,
  FinanceSourceLockoutGuard,
  AuctionDefinitionGuard,
  AppParameterMaintenanceGuard,
  ParameterMaintenanceGuard,
  FinanceSourceMaintenanceGuard,
  CreditSearchGuard,
  EftApprovalGuard,
  FinanceSourceBranchMaintenanceGuard
} from 'smartauction-frontend-micro-library';
import { environment } from 'src/environments/environment';
import { DefaultComponent } from 'remarketing-ui-components-lib';

// Route definitions
export const envRoutes = DEFAULT_ROUTES;
export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [DefaultGuard],
        children: []
      },
      ...envRoutes
    ]
  },
  { path: 'legacy/callback', children: [], canActivate: [LegacyCallbackGuard] },
  { path: 'auth-user/callback', component: AuthCodeComponent, canActivate: [WhiteLabelCallbackGuard] },
  { path: 'dash-auth-user/callback', component: AuthCodeComponent, canActivate: [WhiteLabelCallbackGuard] },
  { path: 'home', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
    data: { environment: environment }
  },
  { path: 'login/admin', children: [], canActivate: [AdminLoginGuard] },
  { path: 'login/admin/error', component: AdminErrorComponent, canActivate: [AdminErrorGuard] },
  { path: 'login/forgot-username', component: ForgotUsernameComponent, canActivate: [LoginGuard] },
  { path: 'logout', component: LogoutComponent },
  { path: 'browser', component: BrowserSuggestionComponent },
  { path: 'error', component: ErrorComponent },
  { path: '404', component: ErrorComponent, data: { type: '404' } },
  { path: 'visibility-error', component: ErrorComponent, data: { type: 'visibility' } },
  // Routing and LD flag guard handled in the fe-statements micro-ui
  {
    path: 'privacy',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/tou/privacy` }
  },
  {
    path: 'privacy/FULL',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/tou/privacy/FULL` }
  },
  {
    path: 'terms-of-use',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/tou/terms-of-use` }
  },
  {
    path: 'terms-of-use/FULL',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/tou/terms-of-use/FULL` }
  },
  {
    path: 'admin-transportation',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/admin-transportation` },
    canActivate: [AdminTransportationGuard]
  },
  {
    path: 'finance-source-fees',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/finance-source-fees` },
    canActivate: [FinanceSourceFeeGuard]
  },
  {
    path: 'data-utility',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/data-utility` },
    canActivate: [DataUtilityGuard]
  },
  {
    path: 'buy-fee-groups',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/buy-fee-groups` },
    canActivate: [BuyFeeGroupsGuard]
  },
  {
    path: 'dealer-search-legacy',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/dealer-search-legacy` },
    canActivate: [DealerSearchGuard]
  },
  {
    path: 'dealer-search',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/dealer-search` },
    canActivate: [DealerSearchV2Guard]
  },
  {
    path: 'holiday-schedule',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/holiday-schedule` },
    canActivate: [HolidayScheduleGuard]
  },
  {
    path: 'simulcast',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/simulcast` },
    canActivate: [SimulcastLandingGuard]
  },
  {
    path: 'message-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/message-maintenance` },
    canActivate: [MessageMaintenanceGuard]
  },
  {
    path: 'branch-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/branch-maintenance` },
    canActivate: [BranchMaintenanceGuard]
  },
  {
    path: 'add-storage-location',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/add-storage-location` },
    canActivate: [AddStorageLocationGuard]
  },
  {
    path: 'feed-submit',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/feed-submit` },
    canActivate: [FeedSubmitGuard]
  },
  {
    path: 'finance-source-lockout',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/finance-source-lockout` },
    canActivate: [FinanceSourceLockoutGuard]
  },
  {
    path: 'auction-definition',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/auction-definition` },
    canActivate: [AuctionDefinitionGuard]
  },
  {
    path: 'app-parameter-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/app-parameter-maintenance` },
    canActivate: [AppParameterMaintenanceGuard]
  },
  {
    path: 'parameter-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/parameter-maintenance` },
    canActivate: [ParameterMaintenanceGuard]
  },
  {
    path: 'finance-source-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/finance-source-maintenance` },
    canActivate: [FinanceSourceMaintenanceGuard]
  },
  {
    path: 'credit-search',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/credit-search` },
    canActivate: [CreditSearchGuard]
  },
  {
    path: 'eft-approval',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/eft-approval` },
    canActivate: [EftApprovalGuard]
  },
  {
    path: 'finance-source-branch-maintenance',
    component: DefaultComponent,
    resolve: { url: 'externalUrlRedirectResolver' },
    data: { externalUrl: `${window.location.protocol}//${location.host}/adm/finance-source-branch-maintenance` },
    canActivate: [FinanceSourceBranchMaintenanceGuard]
  },
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full'
  }
];
